import { useNavigate } from "react-router-dom";
import { Routes } from "routes";
import AddIcon from "@mui/icons-material/Add";
import { useGetAccess } from "../../../common/hooks/useGetAccess/useGetAccess";
import { OdinAccess } from "../../../common/enums";
import { useTranslation } from "react-i18next";

import { Button } from "../../../common/styles/muiStyled";
import { Organisation } from "common/types";
import { CustomerTypes } from "../enums/CustomerTypes";

type Props = {
  selectedCompanyAccess?: Organisation;
};

export const CreateBadgeButton = ({ selectedCompanyAccess }: Props) => {
  const { hasAccess: isCreateRegistrationEnabled } = useGetAccess(OdinAccess.CREATE_NEW_REGISTRATION);
  const { t } = useTranslation("common");

  const history = useNavigate();

  const onClickCreateBadge = () => {
    if (!selectedCompanyAccess) {
      return;
    }

    history(Routes.createBadge, {
      state: {
        selectedCompany: selectedCompanyAccess,
        prefilledCustomerType: CustomerTypes.EXHIBITING_DELEGATE
      }
    });
  };

  const isDisabled = !isCreateRegistrationEnabled || !selectedCompanyAccess;

  return (
    <Button
      disableRipple
      disableElevation
      variant="contained"
      onClick={onClickCreateBadge}
      disabled={isDisabled}
      startIcon={<AddIcon />}
      data-testid="add-badge-button"
      sx={{ padding: "4px 12px", textTransform: "none" }}
    >
      {t("common.buttonLabels.createBadge")}
    </Button>
  );
};
